import React from 'react'
import { Steps, Button, message, Col, Row, Typography } from 'antd';
import '../App.css';
import 'antd/dist/antd.css'; 
import CotizadorInformacionGeneral from './CotizadorInformacionGeneral';
import CotizadorAportes from './CotizadorAportes';
import CotizadorImportes from './CotizadorImportes';

const { Step } = Steps;

const steps = [
  {
    title: 'Información general',
    content: <CotizadorInformacionGeneral/>,
  },
  {
    title: 'Aportes',
    content: <CotizadorAportes/>,
  },
  {
    title: 'Importes',
    content:  <CotizadorImportes/>,
  },
];

export const CotizadorWizzard = () => {

    const {Title}=Typography;

    const [current, setCurrent] = React.useState(0);

    const next = () => {
      setCurrent(current + 1);
    };
  
    const prev = () => {
      setCurrent(current - 1);
    };

    return (
              <>                
                <br/><br/><br/>
                <Row>
                        <Col xs={1} sm={1} md={2} lg={5} ></Col>

                        <Col xs={22} sm={22} md={20} lg={14} >

                              <Title>Cotizador previsional</Title>

                                  <Steps current={current}>
                                    {steps.map(item => (
                                      <Step key={item.title} title={item.title} />
                                    ))}
                                  </Steps>

                                  
                                  <div className="steps-content">{steps[current].content}</div>

                                        <div className="steps-action">
                                          {current < steps.length - 1 && (
                                            <Button type="primary" onClick={() => next()}>
                                              Siguiente
                                            </Button>
                                          )}
                                          {current === steps.length - 1 && (
                                            <Button type="primary" onClick={() => message.success('Processing complete!')}>
                                              Cotizar
                                            </Button>
                                          )}
                                          {current > 0 && (
                                            <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
                                              Anterior
                                            </Button>
                                          )}
                                        </div>
                                  
                              </Col>

                      <Col xs={1} sm={1} md={2} lg={5} ></Col>
                  </Row>                            
              </>
    )
}
